import { BasePlugin } from '../base'
import mdcSwitch from './mdc-switch.vue'

export { mdcSwitch }

export default BasePlugin({
  mdcSwitch
})
